module.exports = __webpack_public_path__ + "static/media/09_tn.feec57da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/09_tn.jpg
// module id = 147
// module chunks = 0